import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TaggedText = _resolveComponent("TaggedText");
  const _component_slot_parent_value = _resolveComponent("slot-parent-value");
  return _openBlock(), _createBlock(_component_slot_parent_value, {
    image: $props.value.image,
    collapsed: $props.collapsed,
    onToggleChildren: _cache[0] || (_cache[0] = $event => _ctx.$emit('toggleChildren'))
  }, {
    default: _withCtx(() => [_createVNode(_component_TaggedText, null, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($props.value.segment), 1)]),
      _: 1
    })]),
    _: 1
  }, 8, ["image", "collapsed"]);
}